<div id="forecast-table-grid-container" class="relative" [style.height]="gridHeight">
  @if (loadingService.loadingCategories(this.rowData) | async) {
    <div
      id="forecast-table-grid-loading-container"
      class="absolute flex"
      [style.height]="gridHeight"
    >
      <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
    </div>
  }
  <ag-grid-angular
    id="forecast-table"
    class="ag-theme-aux mb-8 w-full tabular-nums"
    style="width: 100%; height: 100%"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [context]="context"
    [getRowId]="getRowId"
    (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions"
    auxStickyGrid
  />
</div>
